import { useEffect, useState, type ReactNode } from "react";

/**
 * Floating status message pinned to the top-right of the visible screen, so an
 * error or confirmation is seen wherever the operator has scrolled to.
 * Errors stay until dismissed or replaced; success notices fade after a few seconds.
 */
export function Flash({ tone, children }: { tone: "error" | "success"; children: ReactNode }) {
  const [dismissed, setDismissed] = useState(false);
  const text = typeof children === "string" ? children : null;

  useEffect(() => {
    setDismissed(false);
    if (tone !== "success") return;
    const timer = window.setTimeout(() => setDismissed(true), 8000);
    return () => window.clearTimeout(timer);
  }, [tone, text]);

  if (dismissed) return null;
  return (
    <div className={`admin-flash admin-flash-${tone}`} role={tone === "error" ? "alert" : "status"}>
      <span className="admin-flash-body">{children}</span>
      <button type="button" className="admin-flash-close" aria-label="Dismiss message" onClick={() => setDismissed(true)}>
        ×
      </button>
    </div>
  );
}
